import { message } from 'antd';
import { getUserMe, loginService } from '../services/AuthService';
import { history } from '../utils/history';
import {
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
} from '../reducers/types';
// import { getCurrentUser } from '../services/UserService';
import { getCurrentUserAction } from './UserActions';

export const checkUserLogin = () => {
  return async dispatch => {
    try {
      dispatch({
        type: LOGIN_REQUEST,
      });
      const response = await dispatch(getUserMe());
      if (response.status === 200) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: response.data.username,
        });
      } else {
        dispatch({
          type: LOGIN_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: LOGOUT,
      });
    }
  };
};

export const login = (username, password) => {
  return async dispatch => {
    dispatch({
      type: LOGIN_REQUEST,
    });
    const request = {
      username,
      password,
    };
    try {
      const response = await dispatch(loginService(request));
      if (response.status === 200) {
        localStorage.setItem('userToken', response.headers.authorization);
        dispatch({
          type: LOGIN_SUCCESS,
          payload: username,
        });
        history.push('/');
        dispatch(getUserMe());
        dispatch(getCurrentUserAction());
      } else {
        message.error('Please check your information.', 4);
        dispatch({
          type: LOGIN_FAILURE,
        });
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      dispatch({
        type: LOGIN_FAILURE,
      });
    }
  };
};

export const logout = () => {
  return async dispatch => {
    localStorage.removeItem('userToken');
    dispatch({
      type: LOGOUT,
    });
  };
};
